
import { useI18n } from "vue-i18n"
import {
  format as scoreFormat,
  duration
} from "@/assets/script/utils/sleep-ace.util"

export default {
  props: ["analysis", "summary", "currDate"],
  setup() {
    const { t } = useI18n()
    return { scoreFormat, duration}
  }
}
